import { useMemo } from 'react';

interface IUseCancellationReasonsProps {
  isOnsiteInterview?: boolean;
}

export const useCancellationReasons = ({
  isOnsiteInterview = false,
}: IUseCancellationReasonsProps) => {
  const options = useMemo(
    () =>
      isOnsiteInterview
        ? [
            'A hire has already been made',
            'We no longer need to fill this position',
            'We’d like to reschedule the interview',
            'We’re no longer moving forward with this candidate',
            'Other (please specify)',
          ]
        : [
            'Patients cancelled',
            'Found temporary coverage elsewhere',
            'Current staff was able to cover',
            'Hired a full time employee',
            'Other (please specify)',
          ],
    [isOnsiteInterview],
  );

  return { options };
};
